var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardMediaicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66797 7.5H19.668C20.7288 7.5 21.7462 7.92143 22.4964 8.67157C23.2465 9.42172 23.668 10.4391 23.668 11.5V23.5C23.668 23.7652 23.5626 24.0196 23.3751 24.2071C23.1875 24.3946 22.9332 24.5 22.668 24.5H6.66797C5.6071 24.5 4.58969 24.0786 3.83954 23.3284C3.0894 22.5783 2.66797 21.5609 2.66797 20.5V8.5C2.66797 8.23478 2.77333 7.98043 2.96086 7.79289C3.1484 7.60536 3.40275 7.5 3.66797 7.5V7.5Z",
    stroke: "#FEF3C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.668 14L30.668 10V22L23.668 18",
    stroke: "#FEF3C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMediaicon);
export default __webpack_public_path__ + "static/media/dashboardMedia.icon.b80e919cc7650863f0b430d28f6a268b.svg";
export { ForwardRef as ReactComponent };